module.exports = __webpack_public_path__ + "img/icon_SJCW.2d6914b9.jpg";